import {useEffect} from 'react';

export default function ImperativeFormValues({ imperativeFormControlsRef, setFieldValue }) {
  
  useEffect(() => {
    imperativeFormControlsRef.current = {
      setFieldValue
    };
  }, [setFieldValue, imperativeFormControlsRef]);
  
  return null;
}